<template>
<div class="form-container ou-donation-form rtl" dir="rtl">
  <div class="holder">
      <PaymentForm class="form-horizontal">                
          <FormRow>
            <input type="checkbox" @click="setValue('custom.noAttend', !noAttend)" :checked="noAttend" id="noAttend" class="checkbox-input"/>  <FormLabel for="noAttend" class="forceShow"> אני לא יכול/ה להשתתף אבל אני מעוניין לתרום לכבוד ה"זולה של חצרוני" / צבי סנד </FormLabel>
          </FormRow>                
          <FormSection>
              <FormRow class="note">
                לרכישת כרטיסים בודדים (500 ₪ לכרטיס)
              </FormRow>   
              <FormRow>
                <OuisraelTubshvatAmountsHe />
              </FormRow>      
              <FormRow class="note">
                או לתת חסות
              </FormRow>                              
              <FormRow>
                <AmountSelectorList lang="he"/>                    
                <ErrorLabel field="amount" />                      
              </FormRow>
              <p class="disclaimer">
                * ניתן לרכוש כרטיסים רק על ידי לחיצה על אפשרות "רכישת כרטיס" בודד למעלה. סכומים שהוזנו באפשרות הסכום "אחר" לא ייחשבו לרכישת כרטיס.
              </p>         
              <FormRow>
                <input type="checkbox" @click="setValue('custom.transportation', !transportation)" :checked="transportation" id="transportation" class="checkbox-input"/>                      
                <FormLabel for="transportation" class="forceShow"> אני מעוניין בהסדר הסעה</FormLabel>
              </FormRow>         
          </FormSection>          
          <FormSection>
              <FormRow inline>      
                  <FormCol field="title" :flex="1" lang="he"/>
                  <FormCol field="firstName" :flex="2" />
                  <FormCol field="lastName" :flex="2" />
              </FormRow>
              <FormRow inline>
                  <FormCol field="email" />
                  <FormCol field="phone" />
              </FormRow>                    
          </FormSection>                
          <FormSection last>
              <DonorAddress lang="he"/>
          </FormSection>
              <FormRow inline>
                <FormCol field="card" :showLabel="false" lang="he"/>
              </FormRow>
          <PaymentButton showAmount btnText="המשך לתרומה"/>
      </PaymentForm>
  </div>
</div>
</template>
<script lang="ts">
import { computed, defineComponent, type PropType, ref, watch } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  setup() {
	  const { getValue, setValue, form } = usePaymentForm()
	  const noAttend = computed(() => getValue('custom.noAttend'))
	  const transportation = computed(() => getValue('custom.transportation'))

	  return {
			form,
      noAttend,
      transportation,
			setValue,
			getValue
	  }
  }
})
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.other-means {
  font-size: 14px;
  line-height: 1.6;
}
.note {
  margin: 20px 0;
  font-size: 15px;
  color: #333;
  font-weight: 600;
}
.disclaimer {
  margin: 20px 0;
  font-size: 13px;
  line-height: 1.4;
  color: #575757;
  background: #f7f7f7;
  padding: 10px 20px;
  border: 1px solid #dddddd;
  border-radius: 4px;
}
.checkbox-input {
  margin-right: 5px;
}
</style>

